module.exports = __webpack_public_path__ + "media/assets/images/leanbit_company/azienda_bg-cf0bef5e74a9cfaef600ffb3786a8299.png";